export const getStringBetween = (str: string, start: string, end: string) =>
  str.match(new RegExp(start + '(.*)' + end))?.[1] || ''
